import { AlertCircle } from 'lucide-react'
import { Modal } from '@shared/ui/Modal'
import { useTelegramLinkPolling } from '../model/useLinkTelegramPolling'
import styles from './LinkTelegramWaitModal.module.css'

interface LinkTelegramWaitModalProps {
  /** Колбэк закрытия (вызывается также при успешной связке) */
  onClose: () => void
}

/**
 * Модалка ожидания подтверждения связки Telegram из web-версии.
 * Поллит профиль и закрывается автоматически, когда telegram привязан.
 * @param onClose - Колбэк закрытия
 */
export const LinkTelegramWaitModal = ({ onClose }: LinkTelegramWaitModalProps) => {
  useTelegramLinkPolling(true, () => {
    onClose()
  })

  return (
    <Modal onClose={onClose}>
      <div className={styles.panel}>
        <div className={styles.header}>
          <AlertCircle className={styles.icon} strokeWidth={1.5} aria-hidden="true" />
          <div className={styles.headings}>
            <h3 className={styles.title}>Ждём подтверждения от Telegram</h3>
            <p className={styles.text}>
              Подтвердите связку в открывшемся окне Telegram. Это окно обновится автоматически.
            </p>
          </div>
        </div>
        <button type="button" onClick={onClose} className={styles.closeLink}>
          Закрыть
        </button>
      </div>
    </Modal>
  )
}
